
const ResponseStatus = {
    SUCCESS:'SUCCESS',
    FAILURE:'FAILURE'
}

export default ResponseStatus;